import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';

import { AppRoutingModule } from '../app-routing.module';
import { LandingPageComponent } from './landing-page.component';

/**
 * This Module houses the board that users will see upon entering the application. It will contain a navigation pane at the top
 * and house the content of the application via a series of pages.
 */
@NgModule({
  declarations: [
    LandingPageComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatSidenavModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    MatToolbarModule,
    MatTabsModule,
    MatTableModule,
    AppRoutingModule
  ],
  providers: [
  ],
  exports: [
    LandingPageComponent
  ]
})
export class LandingPageModule { }
